/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import Cookies from 'js-cookie';


export const POST = async ({ url, body, content_type }: { url: string, body: any, content_type?: string }): Promise<any> => {
    const token = await Cookies.get('token') || '';
    const locale = await Cookies.get('language') || 'en';
    const headers: Record<string, string> = {
        'accept': 'application/json',
        'Authorization': token !== '' ? `Bearer ${token}` : '',
        'Accept-Language': locale
    };

    if (!(body instanceof FormData)) {
        headers['Content-Type'] = content_type || 'application/json';
    }

    const response = await fetch(`${process.env.URI}${url}`, {
        method: 'POST',
        headers,
        body: body instanceof FormData ? body : JSON.stringify(body),
    });

    return response.json();
};